  

    <h2 mat-dialog-title>
      <span  class="groupIcon" ><mat-icon>note_add</mat-icon></span>
       Move to another office
      <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
    </h2>
    <mat-dialog-content class="moveToOffice" >    

    
        <div class="tabContainer">
            <div class="d-flex">       
            
                <div class="template-holder">
                 
                 <div class="right">                   
                               
                   <div class="list">
            
                    <div class="tempalteList">
                      <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundOffice">
                        <tr>
                          <th>Office Name</th>             
                          <th class="actBtn">Action</th>
                        </tr>
                        <tr *ngFor="let data of officeList"
                          [ngClass]="{ 'active': data.officeID === selectedOrganizationId}">
            
                          <td class="formName">
                            {{data.officeName}}
                          </td>            
            
                          <td>
                            <button mat-stroked-button color="primary" (click)="SelectOffice(data)">Select</button>                           
                          </td>
                        </tr>

                      </table>
                      <div *ngIf="ShowNoRecordFoundOffice" class="noRecordFound">No Record Found</div>
                    </div>
            
                   </div>
              
                 </div>
              </div>  
    
            </div>
         
          </div>          
      
         
    </mat-dialog-content>

    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-flat-button  color="basic" (click)="close()">Cancel</button>

      <button mat-stroked-button color="primary" class="import" *ngIf="selectedOrganizationId>0"
        (click)="onFolderSelectToMove()">Move
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      </button> 
      
    </mat-dialog-actions>




